<template>

</template>
<script lang="ts" setup>
import type { SocialSharePreviewModel } from '~/models';


const props = defineProps<{model:SocialSharePreviewModel}>();

useSeoMeta({
  ogTitle: props.model.elements.title.value,
  description: props.model.elements.description.value,
  ogDescription: props.model.elements.description.value,
  ogImage: props.model.elements.image.value[0]?.url,
})
</script>